import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs-compat';

@Injectable({
  providedIn: 'root'
})
export class SessionstorageDosService {

  private bloqueoSubject = new BehaviorSubject<boolean>(!!sessionStorage.getItem('liga_compartida_nombre_colaborador'));
  
  // Observable para que los componentes se suscriban
  bloqueo$ = this.bloqueoSubject.asObservable();

  constructor() { }

  // Método para actualizar el estado cuando se guarde algo en el storage
  actualizarEstadoBloqueo() {
    const estado = !!sessionStorage.getItem('liga_compartida_nombre_colaborador');
    this.bloqueoSubject.next(estado);
  }
}
